import { isNative } from "./platform";

export const getApiBaseUrl = (): string => {
  if (isNative()) {
    // Native (Capacitor) has no same-origin to fall back on — fail loud
    // rather than ship a build that hits a non-existent host.
    const url = process.env.REACT_APP_API_URL;
    if (!url) {
      throw new Error(
        "REACT_APP_API_URL must be set for native (Capacitor) builds.",
      );
    }
    return url;
  }
  // On web: empty string = relative URLs, CRA proxy handles dev, same-origin handles prod
  return process.env.REACT_APP_API_URL || "";
};

// Resolve a backend-relative asset path (e.g. "assets/uploads/images/..." or
// "/assets/uploads/images/...") to a URL the browser can load. Pass-through
// for absolute URLs (http/https/data/blob) and empty values.
export const toAssetUrl = (
  path: string | null | undefined,
): string | undefined => {
  if (!path) return undefined;
  if (/^(https?:|data:|blob:)/.test(path)) return path;
  const base = getApiBaseUrl();
  const normalized = path.startsWith("/") ? path : `/${path}`;
  return `${base}${normalized}`;
};
